<script lang="ts" context="module">
  declare const window: any;
</script>

<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Invoices from "@retailer/svelte/Payments/Invoices.svelte";
  import MenuTab from "@retailer/svelte/Payments/MenuTab.svelte";
  import InvoicePaymentSettings from "@retailer/svelte/Payments/InvoicePaymentSettings.svelte";
  import { onDestroy, createEventDispatcher } from "svelte";
  import Credits from "@retailer/svelte/Payments/Credits/Index.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import Authorization from "@shared/svelte/Components/Authorization.svelte";

  enum Tab {
    Invoices = "invoices",
    Credits = "credits",
    PaymentSettings = "payment-settings",
  }

  export let selectedTab: string = Tab.Invoices;

  let specsReadOnly = stagedRolloutCheck("specs_read_only_payments");
  let showUnsavedChangesAlert = false;
  const dispatch = createEventDispatcher();

  const updateShowUnsavedChangesAlert = (newValue: boolean) => {
    showUnsavedChangesAlert = newValue;
  };

  const changeTab = (newTab: Tab) => {
    let switchToNewTab = true;
    if (showUnsavedChangesAlert) {
      switchToNewTab = confirm("Are you sure you want to leave this page with unsaved changes?");
    }

    if (switchToNewTab) {
      selectedTab = newTab;
      showUnsavedChangesAlert = false;
    }
  };

  function showUnsavedChangesAlertWhenRoutingWithinProviLinks() {
    if (showUnsavedChangesAlert) {
      return confirm("Are you sure you want to leave this page with unsaved changes?");
    }
  }
  window.beforeStateChange = showUnsavedChangesAlertWhenRoutingWithinProviLinks; // beforeStateChange observed in angular routing for retailer
  onDestroy(() => (window.beforeStateChange = undefined));

  function showUnsavedChangesAlertWhenReloadingPageOrNavigatingToNonProviUrl(event: any) {
    if (showUnsavedChangesAlert) {
      event.preventDefault();
      const returnValue = "";
      event.returnValue = returnValue; // Chrome requires event.returnValue to be set.
      return returnValue;
    }
  }

  $: {
    dispatch("tabChange", selectedTab);
  }
</script>

<svelte:window
  on:beforeunload={showUnsavedChangesAlertWhenReloadingPageOrNavigatingToNonProviUrl}
/>
<FizzStyles>
  <div class="fizz-container fizz-layout-sidebar-left">
    <nav data-grid-area="sidebar">
      <ul class="fizz-nav-list">
        <MenuTab
          onClick={() => changeTab(Tab.Invoices)}
          isActive={selectedTab === Tab.Invoices}
          text="Invoices"
          activeIcon="InvoiceOn"
          inactiveIcon="Invoice"
          dataTestId="invoices-tab"
        />
        <MenuTab
          onClick={() => changeTab(Tab.Credits)}
          isActive={selectedTab === Tab.Credits}
          text="Credits"
          activeIcon="CreditsBrand"
          inactiveIcon="CreditsGray"
          dataTestId="credits-tab"
        />
        <Authorization authName="payment_instruments.index">
          {#if !specsReadOnly}
            <MenuTab
              onClick={() => changeTab(Tab.PaymentSettings)}
              isActive={selectedTab === Tab.PaymentSettings}
              text="Payment Settings"
              activeIcon="SettingsGearFilled"
              inactiveIcon="SettingsGear"
              dataTestId="payment-settings-tab"
            />
          {/if}
        </Authorization>
      </ul>
    </nav>
    <main data-grid-area="main">
      {#if selectedTab === Tab.Invoices}
        <Invoices />
      {:else if selectedTab === Tab.PaymentSettings}
        <InvoicePaymentSettings {updateShowUnsavedChangesAlert} />
      {:else if selectedTab === Tab.Credits}
        <Credits />
      {/if}
    </main>
  </div>
</FizzStyles>
